import * as React from 'react';
const SvgMaximiseReach = (props) => (
  <svg viewBox="0 0 133 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      clipPath="url(#maximise-reach_svg__a)"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round">
      <path d="M77.518 107.624c-5.654 1.961-15.193 4.403-21.525 4.375C25.832 111.87 1.379 87.29 1.379 56.813S25.832 1.627 55.993 1.627c30.161 0 54.614 24.709 54.614 55.186 0 3.084-.481 7.193-1.333 10.84" />
      <path d="M74.838 96.471c-4.465 6.943-12.83 15.517-18.845 15.517-14.76 0-26.726-24.76-26.726-55.304s11.967-55.3 26.726-55.3c14.759 0 26.726 24.76 26.726 55.304 0 4.352-.709 13.583-1.716 17.039" />
      <path d="M15.205 20.423C25.808 24.5 40.722 27.04 57.243 27.04c16.521 0 29.259-2.03 39.746-5.784M68.27 81.06c-3.695-.281-11.3-.281-12.95-.281-17.502 0-33.233 2.798-44.1 7.247M1.774 56.066h108.352M55.86 2.26v109.728M129.374 106.016c.007-8.457.007-16.918 0-25.374 0-1.832-.554-2.29-2.762-2.29-13.275-.004-26.551-.004-39.827 0-2.18 0-2.73.474-2.73 2.32-.004 8.415-.004 16.832 0 25.246 0 1.875.515 2.321 2.687 2.321h5.186c-.98 4.187-1.44 5.51-2.34 9.145 2.204-2.039 8.64-7.76 10.264-9.145 10.158 0 22.609 0 26.873-.004 2.118 0 2.645-.438 2.649-2.223v.004Z" />
      <path d="m103.43 86.52-.433 13.258 12.512-6.477-12.079-6.782Z" />
    </g>
    <defs>
      <clipPath id="maximise-reach_svg__a">
        <path fill="#fff" d="M0 0h133v120H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMaximiseReach;
